import React from 'react';
import i18n from 'utils/i18n';
import { Button } from 'semantic-ui-react';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();
// loading the sass style fot the component
import css from './styles.module.scss';

/**
 * Molecule CookiesBanner
 * 
 */
function CookiesBanner (props) {
  const t = i18n.useTranslations('components.cookie_consent');
  const bannerRef = React.useRef();

  const {
    className = "",
    onAccept = () => null,
    // onDeny = () => null,
    children,
    ...other
  } = props;

  React.useEffect(_ => {
    // enforcing it will be read
    bannerRef?.current?.focus();
  }, []);

  if (location.pathname === publicRuntimeConfig.TERMS_AND_CONDITIONS) {
    return null;
  }

  return <div
    className={`${css["molecule__cookies-banner-container"]} ${className}`}
    {...other}
  >
    <div
      className={css['content']}
      ref={bannerRef}
      tabIndex={0} // eslint-disable-line
      autoFocus // eslint-disable-line
    >
      <div className={css['title']}>{t('Notice')}</div>
      <div className={css['message']}>
        {t('message')}<br/>
        {t('linkPre')}
        <a
          href={publicRuntimeConfig.TERMS_AND_CONDITIONS}
          target='blank'
        >{t('link')}</a>
        {t('linkPost')}
      </div>
      <div className={css['btns-container']}>
        <Button
          onClick={onAccept}
          color="green"
          size='large'
        >{t('allow')}</Button>
      </div>
    </div>
  </div>;
}

export default CookiesBanner;
